// extracted by mini-css-extract-plugin
export var hidden = "_wc-0";